import { render, staticRenderFns } from "./CustomTimeClock.vue?vue&type=template&id=20b93671&scoped=true"
import script from "./CustomTimeClock.vue?vue&type=script&lang=ts"
export * from "./CustomTimeClock.vue?vue&type=script&lang=ts"
import style0 from "./CustomTimeClock.vue?vue&type=style&index=0&id=20b93671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b93671",
  null
  
)

export default component.exports